import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import '../App.css'
import GetQuoteButton from "../components/GetQuoteButton";
//import "./ShipBuilding.css"; // External CSS if you want
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const ShipBuilding = () => {
  return (
    <div className="sector-detail">
      <Navbar />
      <header className="shipbuilding-hero">
        <h1>Ship & Boat Building</h1>
        <p>
          We specialize in constructing durable, high-performance ships and boats, focusing on
          custom steel fabrication, pipeline systems and full vessel solutions. Our team combines
          precision engineering and expert craftsmanship to deliver excellence on every project.
        </p>
      </header>
      <div className="sector-content">
        <h3 className="offer-title">What We Offer:</h3>
        <p>Entering this sector to serve the regional markets as part of our business development program and we are in 
          discussions with global players in the industry including the establishment of our own shipyard and state-of-the-art
           workshop.</p>
        <ul className="offer-list">
          <li>
            <span className="offer-icon"></span>
            Design and construction of new vessels
          </li>
          <li>
            <span className="offer-icon"></span>
            Custom steel and pipeline fabrication
          </li>
          <li>
            <span className="offer-icon"></span>
            Structural repairs and modifications
          </li>
          <li>
            <span className="offer-icon"></span>
            Complete onboard system installations
          </li>
          <li>
            <span className="offer-icon"></span>
            Drydocking and vessel maintenance solutions
          </li>
        </ul>
      </div>
      <LiveChat />
      <QAChatbot/>
      <GetQuoteButton />
      <ScrollSocialIcons/>
      <BackToTopButton/>
      <Footer />
    </div>
  );
};

export default ShipBuilding;
